import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { cleanIsbd } from '../../../../../shared/pipes/clean-isbd';
import { BrowseIndexItem } from '../../../../../features/browse-index/models';

/**
 * HomeBiblioCard — Presentation Component
 *
 * Home page "أحدث الإضافات" card: cover image, title, author and Hijri date.
 *
 * Distinct from the text-only `app-index-card` used in the browse-index
 * results grid, which has its own layout.
 */
@Component({
  selector: 'app-home-biblio-card',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './home-biblio-card.component.html',
  styleUrl: './home-biblio-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeBiblioCardComponent {
  /** The catalogue item to display */
  @Input({ required: true }) item!: BrowseIndexItem;

  /** True once the cover image URL failed to load */
  imageFailed = false;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  /** Title without ISBD punctuation (the mapper already cleans it; kept for safety) */
  get formattedTitle(): string {
    return cleanIsbd(this.item?.title);
  }

  /** Picks one of four green cover tints, stable per record */
  get coverVariant(): number {
    return (this.item?.id ?? 0) % 4;
  }

  onImageError(): void {
    this.imageFailed = true;
    this.cdr.markForCheck();
  }
}
